export enum ETelemetryEvents {
  ChatFileDownloadSuccess = 'chats.chat-file-download.success',
  ChatFileDownloadFail = 'chats.chat-file-download.fail',
  ChatWsMessageSendSuccess = 'chats.chat-ws-message-send.success',
  ChatWsMessageSendFail = 'chats.chat-ws-message-send.fail',
  ChatWsSessionSuccess = 'chats.chat-ws-session.success',
  ChatWsSessionFail = 'chats.chat-ws-session.fail',
  ChatWsUserStatusSuccess = 'chats.chat-ws-user-status.success',
  ChatWsUserStatusFail = 'chats.chat-ws-user-status.fail',
  ChatPageCrashFail = 'chats.chat-page-crash.fail',
  ChatPageShowErrorPage = 'chats.chat-page-show-error-page',
}
